import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: 'en'
  },
  getters: {
    lang: state => state.lang
  },
  mutations: {
    SET_LANG(state, lang) {
      state.lang = lang
    }
  },
  actions: {
    setLang({ commit }, lang) {
      commit('SET_LANG', lang)
    }
  },
  modules: {
  }
})
